const tabelasColunasFixas = {
  AnaliseCreditoConsultaDetalhada: 'analise_credito_consulta_detalhada',
  ContratosListagem: 'contratos_listagem'
}

export { tabelasColunasFixas }
